import { createSlice } from "@reduxjs/toolkit";

const initState = {
  profileData: {
    isAuth: false,
    user: {
      hasReReferPermission: false,
      _id: "",
      name: "",
      phone: "",
      email: "",
      role: "",
      createdAt: "",
      updatedAt: "",
      ID: "",
    },
    token: ""
  },
};

export const authSlice = createSlice({
  name: "auth",
  initialState: initState,
  reducers: {
    setAuthStateEmpty: () => {
      return initState;
    },
    setUserProfile: (state, action) => {
      const { payload } = action;
      state.profileData = {
        ...state.profileData,
        ...payload,
        isAuth: true,
      };
    },
  },
});
